import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tab, Tabs } from "@mui/material";
import {
  BaseBox,
  BaseTypography,
  BaseTextField,
  BaseButton,
} from "../../../Common/UI/exports";

function Git() {
  const email = localStorage.getItem("email");
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("pr-management");
  const [inputData, setInputData] = useState("");
  const [outputData, setOutputData] = useState("");

  const handleAction = async (action) => {
    try {
      let result;

      switch (action) {
        case "delete-branch":
          // TBC
          break;
        default:
          return;
      }

      setOutputData(result);
    } catch (err) {
      console.error(err);
      setOutputData({ error: err.response?.data || err.message });
    }
  };

  return (
      <BaseBox
        sx={{
          height: "calc(100vh - 140px)",
          display: "flex",
          flexDirection: "column",
          maxWidth: "1160px",
          mx: "auto",
          mt: 0,
          px: 2,
        }}
      >
        <BaseTypography sx={{ fontSize: "1.2rem", mb: 0, fontWeight: 600 }}>
          GIT Utilities
        </BaseTypography>

        <Tabs
          value={activeTab}
          onChange={(_, value) => setActiveTab(value)}
          sx={{ mt: 2, borderBottom: "1px solid #ddd" }}
        >
          <Tab label="PR Management" value="pr-management" />
          <Tab label="Delete Branch" value="delete-branch" />
        </Tabs>

        {activeTab === "pr-management" && (
        <BaseBox
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: 2,
            mt: 2,
          }}
        >
          <BaseBox
            onClick={() => navigate("/util/git/pr-management", { state: { email } })}
            sx={{
              p: 2,
              borderRadius: 2,
              border: "1px solid #ddd",
              backgroundColor: "background.paper",
              cursor: "pointer",
              transition: "all 0.2s ease",
              "&:hover": {
                borderColor: "#1976d2",
                boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
              },
            }}
          >
            <BaseTypography sx={{ fontWeight: 700 }}>
              PR Management
            </BaseTypography>
            <BaseTypography sx={{ color: "text.secondary", mt: 0.5 }}>
              Create pull requests for files across the repositories.
            </BaseTypography>
          </BaseBox>
        </BaseBox>
        )}

        {activeTab === "delete-branch" && (
        <BaseBox
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
        >
          <BaseTextField
            label="Input Data"
            placeholder="input data"
            value={inputData}
            onChange={(e) => setInputData(e.target.value)}
            fullWidth
            multiline
            rows={6}
          />

          {/* Buttons */}
          <BaseBox sx={{ display: "flex", gap: 2 }}>
            <BaseButton
              onClick={() => handleAction("delete-branch")}
              color="info"
            >
              Delete Branch
            </BaseButton>
          </BaseBox>

          {/* Output */}
          <BaseTextField
            label="Output"
            value={typeof outputData === "string" ? outputData : JSON.stringify(outputData || "", null, 2)}
            fullWidth
            multiline
            rows={6}
          />
        </BaseBox>
        )}
      </BaseBox>
  );
}

export default Git;
